export default __webpack_public_path__ + "static/media/women.6bd8dd7b.jpeg";